<script setup>
  const props = defineProps(['disabled']);
  const emit = defineEmits(['loadMore']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section autowrap wide>
    <ShowAnimation fadeOnly
      ><Button @click="emit('loadMore')" outline class="button" :class="{ disabled }"><slot /></Button
    ></ShowAnimation>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    display: flex;
    justify-content: center;

    background-color: $black;
    margin-bottom: -$content-padding-bottom;
    margin-top: px(-128);

    .button {
      &.disabled {
        pointer-events: none;
        opacity: 0.4;
      }
    }

    :deep(> div) {
      display: flex;
      justify-content: center;

      @include break-phone {
        > div {
          width: 100%;
          padding: 0 $margin-phone-wide;
        }
      }
    }
  }
</style>
